const path = {
  home: '/',
  social_redirect_url: '/social-login-int',
  registration_confirmation : "/registration-confirmation",
  registration_phone_confirmation : "/registration-phone-confirmation",
  login: '/login',
  login_phone: '/login-phone',
  forgot_password: '/forget-password',
  forgot_password_phone: '/forget-password-phone',
  forgot_password_confirm: '/forget-password-confirm',
  forgot_password_phone_confirm: '/forget-password-phone-confirmation',
  reset_password : '/reset-password',
  reset_password_phone : '/reset-password-phone',
  registration: '/registration',
  registration_verify_email: "/verify-email",
  registration_verify_phone: "/verify-phone",
  registration_phone: '/registration-phone',
  confirm_signup: '/confirm-signup',
  mentor_registration :'/mentor-registration',
  mentor_confirmation :'/mentor-confirmation',
  mentor_registration_phone_confirmation :'/registration-phone-confirmation',

  course_create: "/course-create",
  course_update: "/course-update",
  mentor_public_profile:"/public-profile",
  profile: "/profile",
  student_public_profile: "/student-public-profile",
  all_course: "/all-course",
  mentor_courses: "/instructor-courses",
  my_cart: "/my-cart",
  course_details: "/course-details",
  course_details_new: "/course-details-new",
  course_enroll: "/course-enroll",
  notification_settings: "/notification-settings",
  instructor_details: '/instructor-details',
  course_list: "/course-list",
  purchase_history: "/purchase-history",
  order_details: "/order-details",
  dashboard: "/dashboard",
  career: "/career",
  our_strength: "/our-strength",
  terms_services: "/terms-services",
  refunc_policy: "/refund-policy",
  privacy_policy: "/privacy-policy",
  site_faq: "/site-faq",
  about_us: "/about-us",
  contact_us: '/contact-us',

  not_found : "/not-found",
  


};

export default path;
